import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ContextMenuIcon',
  props: {
    src: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    class: "context-menu-icon",
    src: _ctx.src,
    alt: "",
    draggable: "false"
  }, null, 8, _hoisted_1))
}
}

})